import { makeStyles } from '@material-ui/core/styles';

interface CheckboxFieldProps {
  isImageLoaded: boolean;
}

export const useStyles = makeStyles(() => ({
  cardImage: {
    height: ({ isImageLoaded }: CheckboxFieldProps) => (isImageLoaded ? 93 : 0),
    width: ({ isImageLoaded }: CheckboxFieldProps) => (isImageLoaded ? 152 : 0),
  },
  cardText: {
    fontSize: 16,
  },
}));
